export default __webpack_public_path__ + "static/media/r2.04118e57.png";